import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import Content from './Content';
import SystemContainer from './SystemContainer';

const RootContainer = ({nameForm}) => {
  if(['SignIn', 'RezultForms', 'Crash'].some(item => nameForm === item))
    return  <SystemContainer nameForm={nameForm} />
  return <Content />
}

RootContainer.propTypes = {
  nameForm: PropTypes.string.isRequired
}

const mapStateToProps = state => ({
  nameForm: state.stateForm.stepNameForm
})
export default connect(mapStateToProps)(RootContainer) 